export default __webpack_public_path__ + "static/media/dashboard.11bbdb96.svg";